/*
  JapanSolved™ Icon Morphology Classifier v2
  Prevents double-framing by classifying each icon before icon selection.
*/
(function () {
  'use strict';

  var ledger = window.JapanSolvedIconTasteExceptionLedger || {};
  var purgedHandles = new Set((ledger.purgedHandles || []).map(function (x) { return String(x).toLowerCase(); }));
  var purgedIds = new Set((ledger.purgedIds || []).map(function (x) { return String(x).toUpperCase(); }));

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function allTokens(icon) {
    var vals = [];
    ['id','filename','handle','cleanLabel','primaryCategory','assetFamily','familyKey','rotationGroup','variantRole','rawBestSectionUse','fillLevel','visualDensity','lineWeight','intensity'].forEach(function (k) {
      if (icon && icon[k]) vals.push(icon[k]);
    });
    ['visualTags','purposeTags','sectionFit','styleFamily','solutionPillars','pageWingFit','categoryTokens','searchTokens'].forEach(function (k) {
      (icon && icon[k] || []).forEach(function (v) { vals.push(v); });
    });
    return vals.map(norm);
  }

  function classify(icon) {
    if (!icon) return null;
    if (icon.morphology && icon.morphology.intrinsicFrame) return icon.morphology;

    var tokens = allTokens(icon);
    var joined = tokens.join(' ');
    var intrinsic = 'none';
    var evidence = [];

    if (/(inside-circle|circle-badge|circle-outline|check-circle|key-inside-circle|coin|seal|badge|orb)/.test(joined)) {
      intrinsic = 'circle';
      evidence.push('circle/coin/badge keyword');
    } else if (/(compass|bullseye|target-precision|radar)/.test(joined)) {
      intrinsic = 'circle-risk';
      evidence.push('compass/target/radar circular geometry');
    } else if (/(rounded-square|square-frame|box-frame|framed|frame)/.test(joined)) {
      intrinsic = 'rounded-square';
      evidence.push('frame/square keyword');
    } else if (/(logo|wordmark)/.test(joined)) {
      intrinsic = 'brand-lockup';
      evidence.push('brand/logo lockup');
    }

    var objectShape = /(cube|package|box|supply)/.test(joined) ? 'cube/package' : 'none';
    var containerEligible = intrinsic === 'none';
    var freeFloatEligible = intrinsic !== 'brand-lockup';
    var recommended = intrinsic === 'none' ? 'boxed-or-free' : (intrinsic === 'brand-lockup' ? 'brand-only-no-auto-icon' : 'free-only');

    icon.morphology = {
      intrinsicFrame: intrinsic,
      intrinsicFrameEvidence: evidence,
      containerEligible: containerEligible,
      freeFloatEligible: freeFloatEligible,
      doubleFrameRisk: intrinsic !== 'none',
      objectShape: objectShape,
      visualWeight: /minimal|thin/.test(joined) ? 'light' : 'medium',
      recommendedTreatment: recommended,
      boxedSlotRule: containerEligible ? 'eligible' : 'avoid-page-container',
      freeSlotRule: freeFloatEligible ? 'eligible' : 'avoid-auto-icon',
      classificationSource: 'runtime heuristic + registry metadata',
      classifiedAt: 'runtime'
    };
    return icon.morphology;
  }

  function isPurged(icon) {
    if (!icon) return false;
    return purgedIds.has(String(icon.id || '').toUpperCase()) || purgedHandles.has(String(icon.handle || '').toLowerCase()) || purgedHandles.has(norm((icon.filename || '').replace(/\.[a-z0-9]+$/i, '')));
  }

  function wantsBox(slot) {
    if (!slot) return false;
    var attrs = [
      slot.getAttribute('data-jsi-container'),
      slot.getAttribute('data-jsi-frame'),
      slot.getAttribute('data-jsi-treatment'),
      slot.getAttribute('data-jsi-placement'),
      slot.getAttribute('data-jsi-visual-mode')
    ].join(' ').toLowerCase();
    return /(box|boxed|rounded-square|hairline-frame|soft-plate|contained|stamp|card-box)/.test(attrs);
  }

  function isCompatible(icon, slot) {
    if (!icon || isPurged(icon)) return false;
    var m = classify(icon);
    if (!m) return false;
    if (wantsBox(slot) && !m.containerEligible && slot && slot.getAttribute('data-jsi-allow-double-frame') !== 'true') return false;
    if (m.recommendedTreatment === 'reject') return false;
    return true;
  }

  function score(icon, terms) {
    if (!icon || isPurged(icon)) return -999999;
    var m = classify(icon);
    if (!m || m.recommendedTreatment === 'reject') return -999999;
    var hay = allTokens(icon).join(' ');
    var s = Number(icon.defaultPriorityScore || 0);
    (terms || []).forEach(function (t) {
      t = norm(t);
      if (t && hay.indexOf(t) !== -1) s += 20;
    });
    if (m.containerEligible) s += 6;
    if (m.doubleFrameRisk) s -= 18;
    if (m.objectShape === 'cube/package') s -= 8;
    return s;
  }

  function getActiveIcons() {
    return ((window.JapanSolvedIconRegistry || {}).icons || []).filter(function (icon) { return !isPurged(icon); });
  }

  function findBestForSlot(slot, terms) {
    var icons = getActiveIcons().filter(function (icon) { return isCompatible(icon, slot); });
    icons.sort(function (a, b) { return score(b, terms) - score(a, terms); });
    return icons[0] || null;
  }

  function applyRegistryCleanup() {
    var registry = window.JapanSolvedIconRegistry;
    if (!registry || !Array.isArray(registry.icons)) return;
    registry.icons = registry.icons.filter(function (icon) {
      if (isPurged(icon)) return false;
      classify(icon);
      return true;
    });
    registry.count = registry.icons.length;
    registry.morphologyRuntimeApplied = true;
  }


  function boxedGlyphRenderRule(slot) {
    var boxSize = (slot && slot.getAttribute('data-jsi-box-size')) || '66px';
    var safeInset = (slot && slot.getAttribute('data-jsi-box-safe-inset')) || '15%';
    var glyphScale = (slot && slot.getAttribute('data-jsi-glyph-scale')) || '96%';
    return {
      name: 'true-single-box-15-safe-inset',
      containerMode: 'one-visible-border-only',
      boxSize: boxSize,
      safeInset: safeInset,
      glyphSlotPercent: '70%',
      glyphScale: glyphScale,
      pageMadeContainer: true,
      registryOwnedIconOnly: true,
      background: 'transparent',
      innerFill: 'none',
      innerRing: 'none',
      insetShadow: 'none',
      iconShadow: 'none',
      overflowPolicy: 'visible',
      clipPolicy: 'none',
      doubleFrameAllowed: false,
      notes: 'Boxed icon means one outer page-made border and one registry glyph floating inside with roughly 15% optical safe-area inset.'
    };
  }

  function enforceBoxEligibility(icon, slot) {
    var m = classify(icon);
    if (!m) return false;
    if (!wantsBox(slot)) return true;
    if (slot && slot.getAttribute('data-jsi-allow-double-frame') === 'true') return true;
    return m.intrinsicFrame === 'none' && m.containerEligible === true;
  }

  window.JapanSolvedIconMorphologyClassifier = {
    version: '2026-07-08.morphology-classifier.v2.true-single-box-safe-inset',
    classify: classify,
    isPurged: isPurged,
    wantsBox: wantsBox,
    isCompatible: isCompatible,
    enforceBoxEligibility: enforceBoxEligibility,
    boxedGlyphRenderRule: boxedGlyphRenderRule,
    score: score,
    getActiveIcons: getActiveIcons,
    findBestForSlot: findBestForSlot,
    applyRegistryCleanup: applyRegistryCleanup
  };

  applyRegistryCleanup();
})();
